(function() {
    'use strict';

    angular
        .module('awizApp')
        .config(function ($stateProvider) {
            $stateProvider.state('jhi-metrics', {
                parent: 'admin',
                url: '/metrics',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'metrics.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/metrics/metrics.html',
                        controller: 'JhiMetricsMonitoringController',
                        controllerAs: 'vm'
                    }
                }
            });
        });

})();
